// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"wp-z","breadcrumbForward":"xp-z","breadcrumbBack":"yp-z","selected":"zp-z"};